import { ACTION } from "@learningblocks/storybook-components/lib/StreakCounter/StreakCounter.utils";
import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  inScene: true
};

export function CuvetteSealReducer(
  state = { cuvetteSeals: [] },
  action
) {
  let currentCuvetteSeal;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_CUVETTE_SEAL" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("cuvetteSeals")
      ) {
        currentCuvetteSeal =
          state.protocolSection.scene.apparatus.cuvetteSeals[
            findIndex(state.protocolSection.scene.apparatus.cuvetteSeals, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_CUVETTE_SEAL":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("cuvetteSeals")) {
        protocolSection.scene.apparatus.cuvetteSeals = [
          ...protocolSection.scene.apparatus.cuvetteSeals,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.cuvetteSeals = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
      
      case "SET_CUVETTE_SEAL_HELD":
        currentCuvetteSeal.held = action.payload.held;
        protocolSection.scene.apparatus.cuvetteSeals[findIndex(state.protocolSection.scene.apparatus.cuvetteSeals, { id: action.payload.id })] = currentCuvetteSeal;
        return { ...state, ...{ protocolSection: protocolSection } };
        
      case "SET_CUVETTE_SEALS_IN_SCENE":
        console.log("SET CUVETTE VISBLE "+ action.payload.inScene);
      //Payload = {inScene}
      currentCuvetteSeal.inScene = action.payload.inScene;
      protocolSection.scene.apparatus.cuvetteSeals[findIndex(state.protocolSection.scene.apparatus.cuvetteSeals, { id: action.payload.id })] = currentCuvetteSeal;
      return { ...state, ...{ protocolSection: protocolSection } };
      
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('cuvetteSeals')) {
        protocolSection.scene.apparatus.cuvetteSeals =
          action.payload.lastState.scene.apparatus.cuvetteSeals;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
